define('datakit/util/url',['backbone', 'underscore'], function(Backbone, _) {
  var namedParam    = /:([\w\.]+)/g;

  var url = {
    template: function(urlPath) {
      var sources = _.rest(arguments);
      return String(urlPath == null ? '' : urlPath)
        .replace(namedParam, function(match, name) {
          for (var i = 0, isModel, source; i < sources.length; i++) {
            source = sources[i];
            isModel = (source instanceof Backbone.Model)
            if (isModel ? source.has(name) : _.has(source, name)) {
              return encodeURIComponent(isModel ? source.get(name) : source[name])
            }
          };
        });
    },

    compile: function(urlPath) {
      return function() {
        var args = _.toArray(arguments);
        return url.template.apply(url, [urlPath].concat(args));
      };
    }
  };

  return url;
});

